<template>
    <div class="sb-simple-airport-products-list" data-test="sb-simple-airport-products-list">
        <UiProductsSectionsSimpleAirportProductsList v-editable="blok" :blok="blok" />
    </div>
</template>

<script lang="ts" setup>
import type { ISimpleAirportProductsList } from '@nuxt-monorepo/ui/types/components/ProductSections/SimpleAirportProductsList';

defineProps<{
    blok: ISimpleAirportProductsList;
}>();
</script>

<style lang="postcss" scoped></style>
